if (!customElements.get('blog-posts-grid')) {
  customElements.define(
    'blog-posts-grid',
    class BlogPostsGrid extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-blog-grid-list]');
        this.posts = Array.from(this.querySelectorAll('[data-blog-grid-post]'));
        this.filterButtons = Array.from(this.querySelectorAll('[data-blog-grid-filter]'));
        this.sortSelect = this.querySelector('[data-blog-grid-sort]');
        this.emptyState = this.querySelector('[data-blog-grid-empty]');
        this.activeFilter = 'all';

        this.onFilterClick = this.onFilterClick.bind(this);
        this.onSortChange = this.onSortChange.bind(this);

        if (!this.list || !this.posts.length) return;

        this.filterButtons.forEach((button) => {
          button.addEventListener('click', this.onFilterClick);
        });

        if (this.sortSelect) {
          this.sortSelect.addEventListener('change', this.onSortChange);
        }

        this.applyState();
      }

      disconnectedCallback() {
        this.filterButtons.forEach((button) => {
          button.removeEventListener('click', this.onFilterClick);
        });

        if (this.sortSelect) {
          this.sortSelect.removeEventListener('change', this.onSortChange);
        }
      }

      onFilterClick(event) {
        const button = event.currentTarget;
        this.activeFilter = this.normalizeTag(button.dataset.blogGridFilter || 'all');

        this.filterButtons.forEach((filterButton) => {
          const isActive = filterButton === button;
          filterButton.classList.toggle('is-active', isActive);
          filterButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.applyState();
      }

      onSortChange() {
        this.applyState();
      }

      getSortValue() {
        return this.sortSelect?.value || 'featured';
      }

      getSortedPosts() {
        const sortValue = this.getSortValue();
        const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });
        const posts = [...this.posts];

        posts.sort((first, second) => {
          if (sortValue === 'newest') {
            return this.getNumber(second, 'date') - this.getNumber(first, 'date');
          }

          if (sortValue === 'oldest') {
            return this.getNumber(first, 'date') - this.getNumber(second, 'date');
          }

          if (sortValue === 'title-asc') {
            return collator.compare(first.dataset.title || '', second.dataset.title || '');
          }

          if (sortValue === 'title-desc') {
            return collator.compare(second.dataset.title || '', first.dataset.title || '');
          }

          if (sortValue === 'read-time') {
            return this.getNumber(first, 'readTime') - this.getNumber(second, 'readTime');
          }

          return this.getNumber(first, 'index') - this.getNumber(second, 'index');
        });

        return posts;
      }

      getNumber(post, key) {
        const value = Number.parseInt(post.dataset[key] || '0', 10);
        return Number.isFinite(value) ? value : 0;
      }

      normalizeTag(value) {
        return String(value || '').trim().toLowerCase();
      }

      postMatchesFilter(post) {
        if (this.activeFilter === 'all') return true;

        const postTags = (post.dataset.tags || '')
          .split('|')
          .map((tag) => this.normalizeTag(tag))
          .filter(Boolean);

        return postTags.includes(this.activeFilter);
      }

      applyState() {
        const sortedPosts = this.getSortedPosts();
        const visiblePosts = [];

        sortedPosts.forEach((post) => {
          const isVisible = this.postMatchesFilter(post);
          post.toggleAttribute('hidden', !isVisible);
          post.classList.toggle('is-hidden', !isVisible);
          post.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
          post.classList.remove('is-featured', 'is-rail');

          if (isVisible) {
            visiblePosts.push(post);
          }

          this.list.append(post);
        });

        visiblePosts.forEach((post, index) => {
          post.classList.toggle('is-featured', index === 0);
          post.classList.toggle('is-rail', index === 1 || index === 2);
        });

        if (this.emptyState) {
          this.emptyState.hidden = visiblePosts.length > 0;
        }
      }
    }
  );
}
